// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1vxdf","productName":"Table_productName__3WHRZ"};